<template>
    <div
        class="modal fade"
        tabindex="-1"
        role="dialog"
        aria-labelledby="chat-modal"
        aria-hidden="true"
        :id="id"
    >
        <div
            class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
            role="document"
        >
            <div class="modal-content" >
                <div class="modal-header">
                    <h4 class="modal-title text-align-center">
                        Update Your Chat Title
                    </h4>
                    <button @click="closeModal(`#${id}`)" type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Chat Title"
                            v-model="chatStore.title"
                        />
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-12 d-flex flex-sm-row flex-column justify-content-center">
                        <button @click="chatStore.updateChat()" class="btn btn-primary mr-sm-1 mb-1 mb-sm-0">
                            Update Chat
                        </button>
                        <button @click="closeModal(`#${id}`)" type="button" data-dismiss="modal" class="btn btn-outline-warning">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { ref } from 'vue'
    import { useChatStore } from '../../stores/ChatStore.js'
    import { closeModal, hideModal } from '../../utilities/_helpers'
    export default {
        mounted() {
        },
        setup() {
            return {
                chatStore: useChatStore(),
                hideModal: hideModal,
                closeModal: closeModal,
            }
        },
        props:{
            id: String,
        },
        methods:{
        }
    }
</script>
